import {
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';

import {
  getFilterSelectStyles,
  menuItemStyles,
} from '@modules/_shared/components/feed-v2/components/ActivityFilters/filterSelectStyles';
import { useLocale } from '@shared/hooks/locale';

type DateRange = 'week' | 'month' | '3months' | 'all';

type DateRangeSelectProps = {
  value: DateRange;
  onChange: (range: DateRange) => void;
};

export type { DateRange };

export const DateRangeSelect = ({ value, onChange }: DateRangeSelectProps) => {
  const { t } = useLocale();

  const options: { value: DateRange; label: string }[] = [
    { value: 'week', label: t('Last week') },
    { value: 'month', label: t('Last month') },
    { value: '3months', label: t('Last 3 months') },
    { value: 'all', label: t('All time') },
  ];

  return (
    <FormControl
      size="small"
      sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: 0 }}
    >
      <Select
        value={value}
        onChange={e => onChange(e.target.value as DateRange)}
        input={<OutlinedInput />}
        renderValue={selected => {
          const option = options.find(o => o.value === selected);
          return option?.label ?? '';
        }}
        MenuProps={{
          slotProps: {
            paper: { sx: { borderRadius: '8px', mt: 0.5 } },
          },
        }}
        sx={getFilterSelectStyles(value !== 'month')}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value} sx={menuItemStyles}>
            <Typography variant="body2">{option.label}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
